import { API } from "aws-amplify";
import { useQuery } from "react-query";
import { ICompleteGeneialSchemaVersion } from "../../../../routes/registries/models/GeneialSchema";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (
  registryId: string
): Promise<ICompleteGeneialSchemaVersion> => {
  const qParams = {};

  return API.get(
    APIEndpoints.private,
    `/api/v1/registries/${registryId}/schema`,
    qParams
  );
};

export default function useReadRegistrySchema(registryId) {
  return useQuery(
    QueryKeys.registrySchemaDetail(registryId),
    () => makeApiRequest(registryId),
    {
      staleTime: 0,
      retry: 1,
      enabled: !!registryId,
    }
  );
}
